interface ApiRequest {
  url: string;
  method: "GET" | "POST" | "PUT" | "DELETE";
  body?: any;
  headers?: Headers;
}

const doFetch = async (apiRequest: ApiRequest, mock = false) => {
  try {
    const result = await fetch(
      `/${process.env.REACT_APP_PREFIX}/${mock ? "mock_" : ""}api/${apiRequest.url}`,
      {
        method: apiRequest.method,
        body: apiRequest.body ? JSON.stringify(apiRequest.body) : undefined,
        headers: apiRequest.headers || new Headers({ "Content-Type": "application/json" }),
        credentials: "same-origin"
      }
    );
    if (!result.ok) throw result;
    return result;
  } catch (error) {
    //let parsedError = undefined;
    console.warn("ERROR");

    try {
      // parsedError = await (error as any).json().catch(() => {}); // TODO: remove?
    } finally {
      return await Promise.reject(error);
    }
  }
};

export const fetchGet = async (url: string, mock = false) => {
  return await doFetch(
    {
      url,
      method: "GET"
    },
    mock
  );
};

export const fetchPost = (url: string, body: any, headers?: Headers) =>
  doFetch({
    url,
    method: "POST",
    body,
    headers
  });

export const fetchPut = (url: string, body: any) =>
  doFetch({
    url,
    method: "PUT",
    body
  });

export const fetchDelete = (url: string, body?: any) =>
  doFetch({
    url,
    method: "DELETE",
    body
  });
